import { Apis } from "../../../lib/Apis";

export const similarInteriorDesignHook = () => {
    const getSimilarInteriorDesignData = async (setSimilarInteriorDesignData, similarId) => {
        try {
            const response = await Apis.getSimilarInteriorDesign(similarId);
            setSimilarInteriorDesignData(response.data.data);
            return response.data.data
        } catch (error) {
            console.error(error);
            return error
        }
    }
    
    const getSimilarInteriorDesignExpectSelected = async (setListingData, designId) => {
        try {
            const response = await Apis.getSimilarInteriorDesignExpectSelected(designId);
            setListingData(response.data);
            return response.data.data
        } catch (error) {
            console.error(error);
            return error
        }
    }
    
    const addSimilarInteriorDesign = async (data) => {
        try {
            const response = await Apis.addSimilarInteriorDesign(data);
            return response.data
        } catch (error) {
            console.error(error);
        }
    }
    
    const deleteSimilarInteriorDesign = async (id) => {
        try {
            const response = await Apis.removeSimilarInteriorDesign(id);
            return response.data
        } catch (error) {
            console.error(error);
        }
    }

    const updateSimilarInteriorDesignPosition = async (id, position) => {
        try {
            const response = await Apis.updateSimilarInteriorDesignPosition(id, position);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }
    
    return {
        getSimilarInteriorDesignData,
        addSimilarInteriorDesign,
        deleteSimilarInteriorDesign,
        getSimilarInteriorDesignExpectSelected,
        updateSimilarInteriorDesignPosition,
    }
}
